<template>
  <div class="report-table-with-refund">
  <el-table
    ref="elTable"
    :data="data"
    :style="`width: ${width}`"
    stripe
    class="egl-table list-table"
    @sort-change="sortChange_fn"
    @filter-change="filterChange_fn"
  >
    <template v-for="(item, idx) in title">
      <el-table-column
        :key="idx"
        v-if="idx === 0"
        :prop="item.prop"
        :label="item.label"
        :min-width="item.width"
        :formatter="tableFormatter_fn"
      ></el-table-column>
      <el-table-column
        :key="idx"
        v-else-if="idx === 1"
        :prop="item.prop"
        :label="item.label"
        :min-width="item.width"
        :formatter="tableFormatter_fn"
        sortable="custom" />
      <el-table-column
        :key="idx"
        v-else-if="idx === 10"
        :prop="item.prop"
        :label="item.label"
        :min-width="item.width"
        :filters="paymentNameArr"
        column-key="paymentTypeId"
      />
      <el-table-column
        :key="idx"
        v-else-if="item.prop === 'statusText'"
        :prop="item.prop"
        :label="item.label"
        :min-width="item.width"
        :formatter="tableFormatter_fn"
        :filters="statusArr"
        :filtered-value="statusKeys"
        column-key="status"
      />
      <el-table-column
        :key="idx"
        v-else
        :prop="item.prop"
        :label="item.label"
        :min-width="item.width"
        :formatter="tableFormatter_fn"
      />
    </template>
    <el-table-column :label="$locale('global.control')" width="250" align="center">
      <template slot-scope="scope" v-if="scope.row.type !== 'nonArrivalTicket'">
        <div class="handle">
          <a @click="openDialog('info', scope.row)">{{ $locale('global.detail') }}</a>
          <template v-if="scope.row.itemStatus === 'pendingPayment'">
            <el-divider direction="vertical"></el-divider>
            <a @click="confirmCancelZeroTicket_fn(scope.row)">{{ $locale('global.cancelRefund') }}</a>
          </template>
          <template v-if="scope.row.itemStatus === 'success'">
            <template v-if="scope.row.seatName !== '未着'">
              <el-divider direction="vertical"></el-divider>
              <a @click="openDialog('edit', scope.row)">{{ $locale('global.edit') }}</a>
            </template>
            <template v-if="$route.path.indexOf('transaction-history') > -1">
              <el-divider direction="vertical"></el-divider>
              <a @click="refund_fn(scope.row)">{{ $locale('trans.report.action.refunded') }}</a>
            </template>
            <!-- <el-divider direction="vertical"></el-divider>
            <a
              @click="deleteRow(scope.row)"
            >{{ $locale('global.delete') }}</a> -->
          </template>
        </div>
      </template>
    </el-table-column>
  </el-table>
  <MultiSelectRefundDialog
    :visible="showMultiSelectDialog"
    :items="cartRefundItems"
    :defaultSelected="clickedTransactionItemId"
    @confirm="onMultiSelectConfirm"
    @cancel="showMultiSelectDialog = false"
  />
  </div>
</template>

<script>
import { toThousands } from "@/utils/common";
import { refundTransactionTicketService, transactionRefundCheckService, shoppingCartRefundItemsService, refundMultipleCheckService, refundMultipleTicketService } from "@/helpers/service/api/report";

import { formatStringFixed } from '@/utils/common';
import MultiSelectRefundDialog from './MultiSelectRefundDialog.vue';
// GMO 決済は type でクレジット / PayPay を区別して表示する。DEV-11231
const GMO_PAYMENT_NAMES = { gmo: "GMOPG(クレジット)", paypayGmo: "GMOPG(paypay)" };
const paymentDisplayName = item => GMO_PAYMENT_NAMES[item.type] || item.name;
export default {
  components: { MultiSelectRefundDialog },
  props: ["title", "data", "width", "size", "currentPage", "filmList", "paymentTypeList", "goodList", "salesStatusObj", "taxRatesMapObj", "type"],
  methods: {
    openDialog(type, data) {
      this.$parent.toggle(type);
      this.$parent.setDetailData(data);
    },
    deleteRow(data) {
      this.$parent.delete(data);
    },
    tableFormatter_fn(row, column, cellValue, index) {
      if (this.type === "ticketing") {
        switch(column.property) {
        case "transactionCreateTime":
          return this.$moment(cellValue).format("YYYY-MM-DD HH:mm");
								case "searchId":
										return formatStringFixed(cellValue);
        case "filmName":
          return this.filmList.find(item => item.id === cellValue) ? this.filmList.find(item => item.id === cellValue).name : cellValue;
        case "scheduleStartTime":
          return this.$moment(cellValue).format("YYYY-MM-DD HH:mm");
        case "paymentName":
          return this.paymentTypeList.find(item => item.id === cellValue) ? paymentDisplayName(this.paymentTypeList.find(item => item.id === cellValue)) : cellValue;
        case "total":
          return "¥" + toThousands(cellValue);
        case "statusText":
          return this.salesStatusObj[row.itemStatus];
        default:
          return cellValue;
        }
      } else {
        // return cellValue;
        switch(column.property) {
        case "transactionCreateTime":
          return this.$moment(cellValue).format("YYYY-MM-DD HH:mm");
								case "searchId":
										return formatStringFixed(cellValue);
        case "unitPrice":
          return toThousands(cellValue);
        case "qty":
          return toThousands(cellValue);
        case "total":
          return toThousands(cellValue);
        case "paymentName": {
          // 売店は id ではなく名称が返る場合もあるため両方で照合する。DEV-11231
          const payment = (this.paymentTypeList || []).find(item => item.id === cellValue || item.name === cellValue);
          return payment ? paymentDisplayName(payment) : cellValue;
        }
        case "taxRateText":
          return this.taxRatesMapObj[row.taxRate.toString()];
        case "statusText":
          return this.salesStatusObj[row.itemStatus];
        default:
          return cellValue;
        }
      }
    },
    sortChange_fn({ column, prop, order}) {
      const sortType = {
        descending: "DESC",
        ascending: "ASC"
      };
      this.$parent.sort = sortType[order];
      this.$parent.getHistoryList();
    },
    filterChange_fn(filters) {
      if (filters.status) this.$parent.status_filters = filters.status;
      if (filters.paymentTypeId) this.$parent.payment_filters = filters.paymentTypeId;
      this.$parent.getHistoryList(true);
    },
    refund_fn(obj) {
      // First query the shopping cart to check if batch refund is applicable
      shoppingCartRefundItemsService({
        transactionId: obj.transactionId,
        transactionItemId: obj.transactionItemId
      }).then(res => {
        // interceptor 返回的是 ResultBean 本体，items 在 res.data（而非 res.data.data）
        const cartItems = (res && res.data) || [];
        const clickedItem = cartItems.find(i => i.transactionItemId === obj.transactionItemId);
        const isNoneBundle = !clickedItem || clickedItem.bundleType === 'NONE';

        // Show multi-select dialog for NONE items when cart has > 1 refundable item
        if (isNoneBundle && cartItems.length > 1) {
          this.cartRefundItems = cartItems;
          this.clickedTransactionItemId = obj.transactionItemId;
          this.showMultiSelectDialog = true;
          return;
        }

        // Otherwise use existing single-item refund flow
        this.executeSingleRefund(obj);
      }).catch(() => {
        // Fall back to existing flow on error
        this.executeSingleRefund(obj);
      });
    },
    executeSingleRefund(obj) {
      let confirmHtml;
      if(obj.hasMultiBooksDiscount || obj.comboTicket) {
        if (obj.hasMultiBooksDiscount && obj.comboTicket) {
          confirmHtml = `<i class="egl-confirm-question">?</i><span class="result-text">同じ割引規則規則で購入したチケットがあります。仕様制限により、取引内の全てのチケットが払い戻しますが、よろしいですか？</span>
          <br /><span class="result-text">該当する取引はコンボチケットのため、一緒に販売したチケット／売店アイテムも払い戻ししますが、よろしいでしょうか？</span>`;
        } else if (obj.comboTicket) {
          confirmHtml = `<i class="egl-confirm-question">?</i><span class="result-text">該当する取引はコンボチケットのため、一緒に販売したチケット／売店アイテムも払い戻ししますが、よろしいでしょうか？</span>`
        } else {
          confirmHtml = `<i class="egl-confirm-question">?</i><span class="result-text">同じ割引規則規則で購入したチケットがあります。仕様制限により、取引内の全てのチケットが払い戻しますが、よろしいですか？</span>`;
        }
        this.$confirm(confirmHtml, "", {
          dangerouslyUseHTMLString: true,
          showClose: false,
          showCancelButton: true,
          cancelButtonClass: "egl-btn-white",
          cancelButtonText: this.$locale("global.cancel"),
          showConfirmButton: true,
          confirmButtonClass: "egl-btn-yellow",
          confirmButtonText: this.$locale("trans.report.action.refunded"),
          customClass: "egl-confirm",
          closeOnClickModal: false
        }).then(() => {
          refundTransactionTicketService({
            transactionId: obj.transactionId,
            transactionItemId: obj.transactionItemId
          }).then(res => {
            this.$parent.getHistoryList();
          });
        });
      } else {
        transactionRefundCheckService({
          transactionId: obj.transactionId,
          transactionItemId: obj.transactionItemId
        }).then(res => {
          confirmHtml = `<i class="egl-confirm-question">?</i><span class="result-text">${res.success ? this.$locale("trans.table.base.refundWarning") : this.$locale("trans.table.refundWarning")}</span>`;
            this.$confirm(confirmHtml, "", {
              dangerouslyUseHTMLString: true,
              showClose: false,
              showCancelButton: true,
              cancelButtonClass: "egl-btn-white",
              cancelButtonText: this.$locale("global.cancel"),
              showConfirmButton: true,
              confirmButtonClass: "egl-btn-yellow",
              confirmButtonText: this.$locale("trans.report.action.refunded"),
              customClass: "egl-confirm",
              closeOnClickModal: false
            }).then(() => {
              refundTransactionTicketService({
                transactionId: obj.transactionId,
                transactionItemId: obj.transactionItemId
              }).then(res => {
                this.$parent.getHistoryList();
              });
            });
        })
      }
    },
    onMultiSelectConfirm(selectedItems) {
      if (!selectedItems || selectedItems.length === 0) {
        this.$message.warning(this.$locale("trans.table.base.selectRefundItem"));
        return;
      }
      // 只提交 ticket：combo 捆绑物品是只读从属项，后端会随 combo 票自动一起退，
      // 直接提交非 ticket 会被 refundMultipleCheck 的「仅退票」校验拒绝。
      const items = selectedItems
        .filter(item => item.type === "ticket")
        .map(item => ({
          transactionId: item.transactionId,
          transactionItemId: item.transactionItemId
        }));
      if (items.length === 0) {
        this.$message.warning(this.$locale("trans.table.base.selectRefundItem"));
        return;
      }
      // 与单笔退款一致：check 仅用于决定提示文案（success=false 表示关账期/非当前班次，需更强警告），
      // 不阻断退款；用户二次确认后照常退款。后端 refundMultiple 本身也不查 frozen。
      refundMultipleCheckService({ items }).then(checkRes => {
        const warningKey = (checkRes && checkRes.success) ? "trans.table.base.refundWarning" : "trans.table.refundWarning";
        const confirmHtml = `<i class="egl-confirm-question">?</i><span class="result-text">${this.$locale(warningKey)}</span>`;
        this.$confirm(confirmHtml, "", {
          dangerouslyUseHTMLString: true,
          showClose: false,
          showCancelButton: true,
          cancelButtonClass: "egl-btn-white",
          cancelButtonText: this.$locale("global.cancel"),
          showConfirmButton: true,
          confirmButtonClass: "egl-btn-yellow",
          confirmButtonText: this.$locale("trans.report.action.refunded"),
          customClass: "egl-confirm",
          closeOnClickModal: false
        }).then(() => {
          refundMultipleTicketService({ items }).then(() => {
            // 与单笔退款一致：成功/错误提示均由 axios interceptor 处理，这里只关弹窗 + 刷新列表
            this.showMultiSelectDialog = false;
            this.$parent.getHistoryList();
          }).catch(() => {
            // 后端异常已由 axios interceptor 弹窗提示，这里仅保持对话框打开
          });
        }).catch(() => {
          // 用户取消确认，无需处理
        });
      }).catch(() => {
        // check 抛异常（如已退款/不可退）已由 axios interceptor 弹窗提示
      });
    },
    confirmCancelZeroTicket_fn(obj) {
      const confirmHtml = `<i class="egl-confirm-question">?</i><span class="result-text">取消しすると、押さえた席がリリースされます、よろしいでしょうか？</span>`;
      this.$confirm(confirmHtml, "", {
        dangerouslyUseHTMLString: true,
        showClose: false,
        showCancelButton: true,
        cancelButtonClass: "egl-btn-white",
        cancelButtonText: this.$locale("global.cancel"),
        showConfirmButton: true,
        confirmButtonClass: "egl-btn-yellow",
        confirmButtonText: this.$locale("global.confirm"),
        customClass: "egl-confirm",
        closeOnClickModal: false
      }).then(() => {
        // call api
        this.refund_fn(obj);
        // this.$parent.getHistoryList();
      })
    },
    // slice() {
    //     if (this.size > 0) {
    //         this.data = this.data.slice((this.currentPage - 1)*this.size, this.currentPage * this.size)
    //     } else {
    //         return this.data
    //     }
    // }
  },
  data() {
    return {
      showMultiSelectDialog: false,
      cartRefundItems: [],
      clickedTransactionItemId: "",
      paymentNameArr: [],
      statusArr: [
        {
          text: this.$locale("trans.report.status.success"),
          value: "success"
        },
        // {
        //   text: this.$locale("trans.report.status.cancel"),
        //   value: "cancel"
        // },
        // {
        //   text: this.$locale("trans.report.status.delete"),
        //   value: "delete"
        // },
        // {
        //   text: this.$locale("trans.report.status.expired"),
        //   value: "expired"
        // },
        // {
        //   text: this.$locale("trans.report.status.fail"),
        //   value: "fail"
        // },
        // {
        //   text: this.$locale("trans.report.status.partial_refunded"),
        //   value: "parital_refunded"
        // },
        // {
        //   text: this.$locale("trans.report.status.processing"),
        //   value: "processing"
        // },
        {
          text: this.$locale("trans.report.status.refunded"),
          value: "refunded"
        },
        {
          text: this.$locale("trans.report.status.fail"),
          value: "fail"
        },
        {
          text: this.$locale("trans.report.status.pending"),
          value: "pendingPayment"
        },
        // {
        //   text: this.$locale("trans.report.status.processing"),
        //   value: "confirming"
        // }
      ],
      // statusKeys: ["success", "cancel", "delete", "expired", "fail", "partial_refunded", "processing", "refunded"]
      statusKeys: ["success", "fail", "refunded", "pendingPayment"]
    };
  },
  watch: {
    paymentTypeList(val) {
      if (val.length > 0) {
        this.paymentNameArr = val.map(item => ({
          text: paymentDisplayName(item),
          value: item.id,
        }));
      }
      this.$refs.elTable.columns[10].filteredValue = this.paymentNameArr.map(item => item.value);
      console.log(this.$refs.elTable.columns);
    }
  }
};
</script>
